export default "__VITE_ASSET__DjgPJyMb__"